import { Component, inject, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SeoService } from '@web-client/shared';

@Component({
    selector: 'lib-utility-shell',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule
    ],
    template: `
    <div class="max-w-7xl mx-auto px-4 py-8 min-h-screen">
        <router-outlet></router-outlet>
    </div>
  `,
    styles: []
})
export class UtilityShellComponent implements OnInit {
    @Input() suiteTitle = 'Utility Suite';
    @Input() suitePath = '';
    @Input() suiteIcon = 'apps';
    @Input() themeColor = 'var(--mat-sys-primary)';

    private readonly seoService = inject(SeoService);

    ngOnInit() {
        this.seoService.init();
    }
}

